import { useState } from "react";
import { Document, Thumbnail } from "react-pdf";
import {
  CreateDocumentPortal,
  DocumentError,
  Fallback,
  ImageWithFallback
} from "../../components/SmartRender/AssetItem";
import { cx } from "../../../../utils/classnames";

export const PetAssetItem = ({
  url,
  assetName,
  contentType
}: {
  url: string;
  assetName: string;
  contentType: string;
}) => {
  const [error, setError] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const isImage = contentType?.includes("image/");
  const isPdf = contentType === "application/pdf" && !error;
  const isPhoto = assetName.includes("Photo");

  return (
    <a
      href={url}
      target="_blank"
      className="block shrink-0 rounded-lg text-primary-500 hover:no-underline"
      download
      rel="noreferrer"
    >
      {isImage ? (
        <div className="bg-white pointer-events-none h-full rounded-lg border border-alpha-40 shadow-xs">
          <ImageWithFallback
            src={url}
            alt="Error displaying submitted image"
            className={cx(
              "rounded-t-lg  object-cover",
              isPhoto ? "h-[108px] w-[140px]" : "h-[168px] w-[154px]"
            )}
          />
          <p
            className={cx(
              "px-6 py-2 truncate border-t border-alpha-40 text-center text-xs font-medium text-content-1000 hover:no-underline"
            )}
          >
            {assetName}
          </p>
        </div>
      ) : null}

      {isPdf ? (
        <div className="h-full">
          <Document
            file={url}
            error={<DocumentError setError={setError} />}
            className={cx(
              "bg-white pointer-events-none no-print h-full rounded-lg border border-alpha-40 shadow-xs",
              isPhoto ? "w-[140px]" : "w-[154px]"
            )}
          >
            <div className="px-4 pt-4 flex justify-center">
              <Thumbnail height={isPhoto ? 92 : 152} pageNumber={1} />
            </div>
            <p className="px-6 py-2 truncate border-t border-alpha-40 text-center text-xs font-medium text-content-1000 hover:no-underline">
              {assetName}
            </p>
          </Document>
          <CreateDocumentPortal
            url={url}
            setError={setError}
            docName={assetName}
          />
        </div>
      ) : null}

      {!isImage && !isPdf ? <Fallback /> : null}
    </a>
  );
};
